var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.98671C0 7.25193 0.105357 7.50628 0.292893 7.69382C0.48043 7.88135 0.734784 7.98671 1 7.98671H20.586L16.294 12.2787C16.1118 12.4673 16.011 12.7199 16.0133 12.9821C16.0156 13.2443 16.1208 13.4951 16.3062 13.6805C16.4916 13.8659 16.7424 13.9711 17.0046 13.9734C17.2668 13.9757 17.5194 13.8749 17.708 13.6927L23.708 7.69271C23.8005 7.60072 23.874 7.49134 23.9241 7.37086C23.9742 7.25039 24 7.12119 24 6.99071V6.98671C24 6.85671 23.974 6.72671 23.922 6.60471C23.8722 6.48348 23.7987 6.37335 23.706 6.28071L17.706 0.280712C17.5174 0.0985537 17.2648 -0.00224062 17.0026 3.78026e-05C16.7404 0.00231622 16.4896 0.107485 16.3042 0.292893C16.1188 0.478301 16.0136 0.729114 16.0113 0.991311C16.009 1.25351 16.1098 1.50611 16.292 1.69471L20.586 5.98671H1C0.734784 5.98671 0.48043 6.09207 0.292893 6.27961C0.105357 6.46714 0 6.7215 0 6.98671Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.fdc37ef4171b03afab3adf67c9d5a3e1.svg";
export { ForwardRef as ReactComponent };